import { useQuery } from "@tanstack/react-query";
import { Spin } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import AntTable from "../../components/AntTable/AntTable";
import ClientRowData from "../../components/AntTable/tableRowsData/ClientRowData";
import HeadTable from "../../components/GlobalTable/HeadTable";
import SubInfo from "../../components/admin/common/SubInfo";
import DeleteModal from "../../components/common/DeleteModal";
import SalonLocationsSelect from "../../components/common/SalonLocationsSelect";
import { ListClients, deleteClient } from "../../network/clients";
import { queryKeys } from "../../services/react-query/queryKeys";
import HeaderClients from "./HeaderClients";
const Clients = (props: any) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [searchClient, setSearchClient] = useState("");
  const [clientsFilter, setFilterClient] = useState(null);
  const [idDelete, setIdDelete] = useState(null);
  const [page, setPage] = useState(1);
  const intl = useIntl();
  const { data, isLoading, isError } = useQuery(
    [queryKeys.listClient, searchClient, clientsFilter],
    () => ListClients(clientsFilter, searchClient)
  );

  const showDeleteModal = (id: any) => {
    setIdDelete(id);
    setDeleteModal(true);
  };
  const handleDeleteCancel = () => {
    setDeleteModal(false);
  };
  console.log(data);

  const columns: ColumnsType<any> = [
    {
      title: <FormattedMessage id="customerNameTap" />,
      dataIndex: "first_name",
      render: (text: any, record) => (
        <div className="text-[#9999A7] text-sm font-medium capitalize">
          {record?.first_name + " " + record?.last_name}
        </div>
      ),
    },
    {
      title: <FormattedMessage id="mobileNumberTap" />,
      dataIndex: "phone",
      // responsive: ["lg"],
      render: (text: any) => (
        <div className="text-sm font-medium text-color-primary" dir="ltr">
          {text}
        </div>
      ),
    },
    {
      title: <FormattedMessage id="numberOfReservationsTap" />,
      dataIndex: "appointments_count",

      render: (text: any, record) => (
        <div className="text-[#9999A7] text-sm font-medium">
          <span className="mx-1 font-semibold text-color-primary">
            {record?.appointments_count || 0}
          </span>
          <span className="text-sm font-normal">
            {intl.formatMessage({
              id: "bookedTitle",
            })}
          </span>
        </div>
      ),
    },
    {
      title: <FormattedMessage id="totalSalesTap" />,
      dataIndex: "totalSales",

      render: (text: any, record) => (
        <div className="text-[#9999A7]">
          <SubInfo
            value={record?.totalSales || 0}
            label={intl.formatMessage({
              id: "SARshort",
            })}
          />
        </div>
      ),
    },
    {
      title: <FormattedMessage id="dateAddedTap" />,
      dataIndex: "created_at",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className="text-[#9999A7] text-sm font-medium">
          {dayjs(record?.created_at).format("YYYY-MM-DD")}
        </div>
      ),
    },
  ];
  console.log(data);

  return (
    <div className="">
      <HeaderClients />
      <SalonLocationsSelect />
      <div className="flex flex-col gap-4 p-6 mt-10 bg-white rounded-lg shadow-lg">
        <div className="bg-[#EEF0FF] py-8 pb-0 px-6 rounded-lg overflow-auto">
          <DeleteModal
            visible={deleteModal}
            onClose={handleDeleteCancel}
            onDelete={deleteClient}
            data={idDelete}
            confirmationHeader={intl.formatMessage({
              id: "confirmationHeader",
            })}
            confirmationText={intl.formatMessage({ id: "confirmationText" })}
            queryKey={queryKeys.listClient}
            successMessage="client deleted successfully"
          />
          <HeadTable
            data={data?.data?.data}
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            setSearchClient={setSearchClient}
            setFilterClient={setFilterClient}
            searchClient={searchClient}
            clientsFilter={clientsFilter}
          />
          {isLoading ? (
            <Spin
              size="large"
              className="flex items-center justify-center min-h-[50vh]"
            />
          ) : (
            <AntTable
              tableColumns={columns}
              tableData={data?.data?.data || []}
              isLoading={isLoading}
              setPage={setPage}
              page={page}
              total={data?.meta?.total}
              rowData={(record: any) => (
                <ClientRowData
                  data={record}
                  showDeleteModal={() => showDeleteModal(record.id)}
                  id={idDelete}
                />
              )}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Clients;
